import config from "@/config"
import http from "@/utils/request"

export default {
  article: {
    add: {
      url: `${config.API_URL}/article`,
      name: "新增一个文章管理",
      post: async function (data) {
        return await http.post(this.url, { method: 'add.article.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/article`,
      name: "编辑一个文章管理",
      post: async function (data) {
        return await http.post(this.url, { method: 'set.article.item', ...data });
      }
    },
    status: {
      url: `${config.API_URL}/article`,
      name: "批量编辑文章管理状态",
      post: async function (article_id, status) {
        return await http.post(this.url, { method: 'set.article.status', article_id, status });
      }
    },
    sort: {
      url: `${config.API_URL}/article`,
      name: "批量编辑文章管理排序",
      post: async function (article_id, sort) {
        return await http.post(this.url, { method: 'set.article.sort', article_id, sort });
      }
    },
    top: {
      url: `${config.API_URL}/article`,
      name: "批量编辑文章管理排序",
      post: async function (article_id, is_top) {
        return await http.post(this.url, { method: 'set.article.top', article_id, is_top });
      }
    },
    delete: {
      url: `${config.API_URL}/article`,
      name: "批量删除文章管理",
      post: async function (article_id) {
        return await http.post(this.url, { method: 'del.article.list', article_id });
      }
    },
    item: {
      url: `${config.API_URL}/article`,
      name: "获取一个文章管理详情",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.article.item', ...data });
      }
    },
    bytitile: {
      url: `${config.API_URL}/article`,
      name: "获取一个文章管理详情",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.article.title', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/article`,
      name: "获取文章管理列表",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.article.list', ...data });
      }
    }
  },
  article_cat: {
    add: {
      url: `${config.API_URL}/article_cat`,
      name: "新增一个文章分类",
      post: async function (data) {
        return await http.post(this.url, { method: 'add.article_cat.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/article_cat`,
      name: "编辑一个文章分类",
      post: async function (data) {
        return await http.post(this.url, { method: 'set.article_cat.item', ...data });
      }
    },
    tree: {
      url: `${config.API_URL}/article_cat`,
      name: "获取文章分类树",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.article_cat.tree', ...data });
      }
    },
    status: {
      url: `${config.API_URL}/article_cat`,
      name: "批量编辑文章分类状态",
      post: async function (article_cat_id, status) {
        return await http.post(this.url, { method: 'set.article_cat.status', article_cat_id, status });
      }
    },
    sort: {
      url: `${config.API_URL}/article_cat`,
      name: "批量编辑文章分类排序",
      post: async function (article_cat_id, sort) {
        return await http.post(this.url, { method: 'set.article_cat.sort', article_cat_id, sort });
      }
    },
    delete: {
      url: `${config.API_URL}/article_cat`,
      name: "批量删除文章分类",
      post: async function (article_cat_id) {
        return await http.post(this.url, { method: 'del.article_cat.list', article_cat_id });
      }
    },
    item: {
      url: `${config.API_URL}/article_cat`,
      name: "获取一个文章分类详情",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.article_cat.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/article_cat`,
      name: "获取文章分类列表",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.article_cat.list', ...data });
      }
    }
  }
}
